import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface Region {
  id: number;
  name: string;
}

const fetchRegions = async (): Promise<Region[]> => {
  try {
    const { data } = await api.get<Region[]>('/api/regions');
    return data;
  } catch (error) {
    throw new Error('Error al cargar las regiones');
  }
};

export const useRegions = () => {
  const { data: regions = [] } = useQuery({
    queryKey: ['regions'],
    queryFn: fetchRegions,
  });

  return {
    regions,
  };
}; 